/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 4/12/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const CheckoutService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPaymentMethods: builder.query({
            query: () => "/payment-methods"
        }),

        createRequest: builder.mutation({
            query: (details) => ({
                url: '/reqs',
                method: 'POST',
                body: details
            })
        }),

        stripePay: builder.mutation({
            query: (details) => ({
                url: '/checkout/charge',
                method: 'POST',
                body: details
            })
        }),

    })
});

export const {
    useGetPaymentMethodsQuery,
    useCreateRequestMutation,
    useStripePayMutation,
} = CheckoutService;